import React, { useEffect } from "react";
import {
  AchivementTags,
  CategoryWrapper,
  Heading,
  ProjectBackgroundImageContainer,
  ProjectDataWrapper,
  ProjectInfoTextWrapper,
  ProjectWrapper,
  ProjectWrapperMainTitle,
  ProjectWrapperTitle,
  SkillTags,
  SmallText,
  Subheading,
  Text,
} from "./style";
import { graphql, useStaticQuery } from "gatsby";
import { SiHeroku, SiGithub, SiExpo } from "react-icons/si";
import { VscLink } from "react-icons/vsc";
import { SocialIcon } from "react-social-icons";
import AOS from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
    AOS.refresh();
  }, []);
  const data = useStaticQuery(graphql`
    query {
      allProjectJson {
        edges {
          node {
            description
            main_tile
            categories {
              title
              projects {
                codes
                description
                duration
                endingDate
                heading
                programmingLanguages
                subheading
                startingDate
                techno
                url
              }
            }
          }
        }
      }
    }
  `);
  const projectall = data.allProjectJson.edges[0].node;
  console.log(projectall);
  return (
    <ProjectBackgroundImageContainer>
      <ProjectDataWrapper>
        {/* {projectadata.map((projectall, inu) => ( */}
        <ProjectInfoTextWrapper>
          <ProjectWrapperMainTitle>
            {projectall.main_tile}
          </ProjectWrapperMainTitle>
          <p
            data-aos="zoom-in"
            data-aos-offset="100"
            data-aos-delay="20"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
            data-aos-anchor-placement="top-bottom">
            {projectall.description}
          </p>
          {projectall.categories.map((categories, index) => (
            <CategoryWrapper key={index}>
              <ProjectWrapperTitle>{categories.title}</ProjectWrapperTitle>
              {categories.projects.map((project, key) => (
                <ProjectWrapper
                  key={key}
                  data-aos="zoom-in"
                  data-aos-offset="100"
                  data-aos-delay="20"
                  data-aos-easing="ease-in-out"
                  data-aos-mirror="true"
                  data-aos-once="false"
                  data-aos-anchor-placement="top-bottom">
                  <Heading>{project.heading}</Heading>
                  <Subheading>{project.subheading}</Subheading>
                  <div style={{ display: "block", padding: "5px" }}>
                    {project.duration && (
                      <div style={{ display: "block" }}>
                        <SmallText>{project.duration}</SmallText>
                        <SmallText>{project.startingDate}</SmallText>
                        <SmallText>{project.endingDate}</SmallText>
                      </div>
                    )}
                    {project.techno && (
                      <div style={{ display: "block" }}>
                        <SmallText>
                          {project.techno &&
                            project.techno.map((technology, ti) => (
                              <AchivementTags key={ti}>
                                {technology}
                              </AchivementTags>
                            ))}
                        </SmallText>
                      </div>
                    )}
                    <div style={{ display: "block", padding: "0px" }}>
                      <Text>{project.description}</Text>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        padding: "0px",
                        justifyContent: "center",
                        width: "fit-content",
                      }}>
                      {project.programmingLanguages &&
                        project.programmingLanguages.map((language, li) => (
                          <SkillTags small={true} key={li}>
                            {language}
                          </SkillTags>
                        ))}
                      <div
                        style={{
                          display: "flex",
                          paddingLeft: "10px",
                          justifyContent: "center",
                          width: "fit-content",
                        }}>
                        {project.codes && (
                          <a
                            href={project.codes}
                            target="_blank"
                            style={{
                              marginTop: "5px",
                              padding: "2px",
                              display: "inline-block",
                              fontSize: "18px",
                            }}>
                            {project.codes.includes("github") && (
                              <SiGithub color="#0c0c0c" />
                            )}
                          </a>
                        )}
                        {project.url && (
                          <a
                            href={project.url}
                            target="_blank"
                            style={{
                              marginTop: "5px",
                              padding: "2px",
                              display: "inline-block",
                              fontSize: "18px",
                            }}>
                            {project.url.includes("heroku") && (
                              <SiHeroku color="#002f5a" />
                            )}
                            {project.url.includes("expo") && (
                              <SiExpo color="#0c0c0c" />
                            )}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </ProjectWrapper>
              ))}
            </CategoryWrapper>
          ))}
        </ProjectInfoTextWrapper>
        {/* ))} */}
      </ProjectDataWrapper>
    </ProjectBackgroundImageContainer>
  );
};

export default Projects;
